import axios from 'axios';
import { t } from 'i18next';
import { toast } from 'react-toastify';
import * as axiosConfiguration from './axios.token-configuration';
import { logOut } from '../../auth/services/auth.service';
import { useNavigate } from 'react-router-dom';
import { getCommonErrorTranslate, handleUnauthorizedMessage } from './axios.erros.interceptor.service';
export const addErrorsInterceptor = (): void => {
    axios.interceptors.response.use(
        (response) => {
            return response;
        },
        (error) => {
            if (error.response?.status === 401 && axios.defaults.headers.common['Authorization']) {
                const navigate = useNavigate();
                logOut(navigate);
                toast.error(t(getCommonErrorTranslate('sessionExpired')), {
                    position: 'top-center',
                });
            } else if (error.response?.status > 299 || error.response?.status < 200) {
                if (error.response?.status === 401) {
                    localStorage.removeItem('token');
                    axiosConfiguration.setAuthToken();
                    if (error.response.data?.message) {
                        handleUnauthorizedMessage(error.response.data?.message);
                    } else {
                        handleUnauthorizedMessage('badCredentials');
                    }
                } else {
                    return Promise.reject(error);
                }
            }
        }
    );
};
